import { CustomerCreateRequest } from "../request/customer-create.request";

export class CustomerResponse extends CustomerCreateRequest{
    
    id:number
    active:boolean
    registerDate:string

}